import ContactsDetailContainer from '../../../containers/ContactsDetailContainer'

export const ContactsDetailPage = () => {
  return <ContactsDetailContainer />
}
